import {
  createPlugin,
  createComponentExtension,
} from '@backstage/core-plugin-api';

/**
 * Kubernetes Workloads plugin for Backstage.
 * Provides K8s native workload management on System Entity Pages.
 *
 * @public
 */
export const kubernetesWorkloadsPlugin = createPlugin({
  id: 'kubernetes-workloads',
});

/**
 * System Environments Content — 环境 Tab 主组件
 * 挂载到 System Entity Page，提供环境切换 + 工作负载管理
 *
 * @public
 */
export const SystemEnvironmentsContent = kubernetesWorkloadsPlugin.provide(
  createComponentExtension({
    name: 'SystemEnvironmentsContent',
    component: {
      lazy: () =>
        import('./components/SystemEnvironmentsContent').then(
          m => m.SystemEnvironmentsContent,
        ),
    },
  }),
);

/**
 * System Workflows Content — 工作流 Tab 主组件
 * 挂载到 System Entity Page，展示 Tekton Pipeline 管理
 *
 * @public
 */
export const SystemWorkflowsContent = kubernetesWorkloadsPlugin.provide(
  createComponentExtension({
    name: 'SystemWorkflowsContent',
    component: {
      lazy: () =>
        import('./components/SystemWorkflowsContent').then(
          m => m.SystemWorkflowsContent as any,
        ),
    },
  }),
);

/**
 * Workload Revision Content — Revision Tab 组件
 * 挂载到 Workload Entity Page，展示版本历史
 *
 * @public
 */
export const WorkloadRevisionContent = kubernetesWorkloadsPlugin.provide(
  createComponentExtension({
    name: 'WorkloadRevisionContent',
    component: {
      lazy: () =>
        import('./components/WorkloadRevisionContent').then(
          m => m.WorkloadRevisionContent,
        ),
    },
  }),
);
